import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    transactionTypes: null,
    transactionTypeInfo: null,
  },
  getters: {
    getTransactionTypes: state => state.transactionTypes,
    getTransactionTypeInfo: state => state.transactionTypeInfo,
  },
  mutations: {
    SET_TRANSACTION_TYPES: (state, transactionTypes) => {
      state.transactionTypes = transactionTypes
    },
    SET_TRANSACTION_TYPE_INFO: (state, info) => {
      state.transactionTypeInfo = info
    },
  },
  actions: {
    async fetchTransactionTypes({ commit }) {
      commit('SET_TRANSACTION_TYPES', null)
      const transactionTypes = (await axiosIns.get('transactions/transaction-types')).data.data
      commit('SET_TRANSACTION_TYPES', transactionTypes)
      return transactionTypes
    },
    async createTransactionType(ctx, transactionType) {
      try {
        await axiosIns.post('/transactions/transaction-types', transactionType)
      } catch (error) {
        console.log(error)
      }
    },
    async editTransactionType(ctx, { transactionType, id }) {
      try {
        await axiosIns.patch(`/transactions/transaction-types/${id}`, transactionType)
      } catch (error) {
        console.log(error)
      }
    },
  },
}
